module.exports = __webpack_public_path__ + "img/jl-title.ff37858d.png";